var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "app-modal",
        {
          staticClass: "modalNotificar",
          attrs: { titulo: _vm.titulo, width: 1000 },
          on: { closeModal: _vm.closeModal }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("app-search-despachos", {
                on: { search: _vm.search, input: _vm.search, clear: _vm.clear }
              }),
              _vm.modelos.length === 0
                ? _c("div", [
                    _c("p", { staticClass: "center" }, [
                      _vm._v("Ainda não há modelos disponíveis")
                    ])
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "container-modelo" },
                _vm._l(_vm.modelos, function(item) {
                  return _c("div", { key: item.id, staticClass: "item" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectModelo(item.id)
                          }
                        }
                      },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "cursor-pointer",
                            class: { active: item.id === _vm.selectedModelo.id }
                          },
                          [
                            _c("span", { staticClass: "descricao" }, [
                              _vm._v(_vm._s(item.descricaoTexto))
                            ]),
                            _c("p", { staticClass: "border-bottom" }),
                            _c("p", {
                              domProps: { innerHTML: _vm._s(item.textoModelo) }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c("app-utilizar-buttons", {
                attrs: { textModel: _vm.selectedModelo.textoModelo },
                on: { cancel: _vm.closeModal, confirm: _vm.save }
              })
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8b6aca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8b6aca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalSelecionarModeloNotificacao.vue
// module id = null
// module chunks = 